// store/bookingStore.ts
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface BookingState {
  restore: boolean;
  setRestore: (value: boolean) => void;
}

export const useBookingStore = create<BookingState>()(
  persist(
    set => ({
      restore: false,

      setRestore: (value: boolean) => {
        set({ restore: value });
      },
    }),
    {
      name: 'booking-restore',
    }
  )
);
